/**
 * Make a copy of an object
 * @param {object} data
 * @returns {object}
 */
export default function clone (data) {
  return JSON.parse(JSON.stringify(data))
}
